/**
 * @file Re-exports the Console sidebar.
 */
import Sidebar from "./Sidebar";

export default Sidebar;
